import axios from 'axios';
import config from '../../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../../core/modules/common/tools/URLTools';

const apiFetchOriginImpcOperatorPredesSenderMismatchDetails = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getOriginImpcOperatorPredesSenderMismatchDetails',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchOriginImpcOperatorPredesSenderMismatchDetails;
